import { useLocale } from '../../i18n/context'

export default function SpeakerButton({ onClick, isSpeaking }: { onClick: () => void; isSpeaking: boolean }) {
  const { tr } = useLocale()
  const lbl = isSpeaking ? tr.learn.speakingLabel : tr.learn.pronounceWord
  return (
    <button
      onClick={onClick}
      aria-label={lbl}
      title={lbl}
      style={{
        background: 'none',
        border: `1.5px solid ${isSpeaking ? 'var(--accent)' : 'var(--border)'}`,
        borderRadius: 50,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        minWidth: 36,
        color: isSpeaking ? 'var(--accent)' : 'var(--text-secondary)',
        transition: 'color 0.15s, border-color 0.15s, transform 0.15s',
        transform: isSpeaking ? 'scale(1.1)' : 'scale(1)',
        flexShrink: 0,
      }}
    >
      {/* Speaker SVG icon — filled when speaking */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={isSpeaking ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ display: 'block' }}
      >
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
        {isSpeaking ? (
          <>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          </>
        ) : (
          <>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" strokeOpacity="0.4" />
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" strokeOpacity="0.4" />
          </>
        )}
      </svg>
    </button>
  )
}
